import { createAction, props } from '@ngrx/store';
import { UserSession } from './../models/session.model';

export const setSession = createAction(
  '[Session] Set Session',
  props<UserSession>()
);

export const removeSession = createAction('[Session] Remove Session');

export const NoopAction = createAction('Noop Action');
